import React, { useState } from "react";
import './Components.css'
import { Trans } from "react-i18next";
import { Card, Table } from "reactstrap";
import { formatDateName } from "services/util";

export const HistoryComponent = ({ historyItem, type, t }) => {

    const [isHistoryVisible, setHistoryVisibility] = useState()
    
    const renderToggleIcon = () => (isHistoryVisible ? '▲' : '▼');

    const toggleHistoryVisibility = () => {
        setHistoryVisibility(!isHistoryVisible);
    };

    const handleDetailsClick = (item) => {
        setHistoryVisibility(item);
    };
   
    return (
  <div className="pt-3">
    <div>
        <span
         className="toggle-button"
         onClick={toggleHistoryVisibility}
         style={{
            cursor: 'pointer',
            alignItems: 'center',
            fontSize: '1.2em',
         }}
          >{isHistoryVisible ? t("Hide") : t("Show")} <Trans>History & Notes</Trans> <span style={{ marginRight: '5px', fontWeight: 'bold' }}>{renderToggleIcon()}</span>

        </span>
    </div>
   {isHistoryVisible && (
    <Card className="p-3 mt-3" >
      <h3><Trans>{type || ""} History:</Trans></h3>
      <Table>
        <tbody>
          {historyItem.map((item, index) => (
            <tr key={index} onClick={() => handleDetailsClick(item)}>
              <td
                className={`text-left history-td-${index}`}>
                <p style={{ fontSize: "1.1em", cursor: "pointer" }}><strong>{item.Changes}</strong> By {item.User === "System Generated" ? "Auto Generation System" : item.User} on {formatDateName(item.DateUTCString)}</p>
                {isHistoryVisible === item && (
                  <div><p style={{ fontStyle: "italic" }}> {item.Details}</p></div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  )}
</div>
)};

export default HistoryComponent;